import { Transition } from "../../../core/flows/Transition";
import { RetrieveBookingContext } from "../../RetrieveBooking/Context/RetrieveBookingContext";

export class AfterSaleUpcomingTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        
        const retrieveBookingContext = new RetrieveBookingContext()
        this.setCtx<RetrieveBookingContext>("retrieveBookingContext", retrieveBookingContext, this.entryStep)
        const context = this.getCtx<RetrieveBookingContext>("retrieveBookingContext", this.entryStep);
        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }        
        context.routeTo = ["RetrieveBookingFlow"]

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}